import React from 'react';

import { SnackbarProvider } from 'notistack';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { Init as InitSystem } from './apps/system/Init';
import { Init as InitTowerPhotos } from './apps/towerphotos/Init';

import './styles/App.css';
import './styles/MaterialUi.css';

export default function App() {
	return (
		<SnackbarProvider
			maxSnack={5}
			autoHideDuration={3000}
			anchorOrigin={{
				horizontal: 'left',
				vertical: 'bottom'
			}}
		>
			<BrowserRouter>
				<Switch>
					<Route path="/system" exact component={InitSystem} />
					<Route path="/towerphotos" exact component={InitTowerPhotos} />
					{/*
					<Route path="*" render={() => 'Error! Page not found.'} />
					*/}
					<Route path="*" component={InitSystem} />
				</Switch>
			</BrowserRouter>
		</SnackbarProvider>
	);
};